module.exports = __webpack_public_path__ + "img/运营活动.46fdbad3.png";